import React, { useEffect, createContext, useState } from 'react';
import { useMemo } from 'react';
import { demoPages } from '../menu';
import { useLocation, useNavigate } from 'react-router-dom';
export const userAuth = createContext({});

const UserContextProvider = ({ children }) => {
	const [token, setToken] = useState({});
	const [menudemopages, setMenudemopages] = useState({ ...demoPages });
	//
	const [loading, setLoading] = useState(true);
	const [reset, setReset] = useState(true);
	const location = useLocation();
	const navigate = useNavigate();
	const [pathpermission, setPathpermission] = useState([]);
	const normalizeKey = (value) => `${value ?? ''}`.trim().toLowerCase();
	const stripLeadingSlashes = (value) => normalizeKey(value).replace(/^\/+/, '');
	const collapseAlias = (value) => stripLeadingSlashes(value).replace(/[\s/_-]+/g, '');
	const toAliasVariants = (value) => {
		const normalized = stripLeadingSlashes(value);
		const collapsed = collapseAlias(value);
		const variants = [normalized, collapsed];

		if (normalized.endsWith('s')) {
			variants.push(normalized.slice(0, -1));
		}
		if (collapsed.endsWith('s')) {
			variants.push(collapsed.slice(0, -1));
		}

		return [...new Set(variants.filter(Boolean))];
	};
	const cloneMenu = () => JSON.parse(JSON.stringify(demoPages));
	const ensureWorkerSettingsMenu = (menu) => {
		const baseSettings = cloneMenu().Manage_setting;

		if (!menu.Manage_setting) {
			menu.Manage_setting = baseSettings;
			if (menu.Manage_setting?.subMenu?.sliderSetting) {
				menu.Manage_setting.subMenu.sliderSetting.hide = true;
			}
			if (menu.Manage_setting?.subMenu?.activityLog) {
				menu.Manage_setting.subMenu.activityLog.hide = true;
			}
			return;
		}

		if (menu.Manage_setting?.subMenu?.employeeSetting) {
			menu.Manage_setting.subMenu.employeeSetting.hide = false;
		}
	};
	const upsertPathPermission = (list, path, permission = []) => {
		if (!path) return;
		const index = list.findIndex((item) => item.path === path);
		const nextPermission = Array.isArray(permission) ? permission : [];

		if (index !== -1) {
			list[index] = { ...list[index], permission: nextPermission };
			return;
		}

		list.push({ path, permission: nextPermission });
	};
	const toAliasSet = (item = {}) => {
		const customAliases = Array.isArray(item.aliases)
			? item.aliases
			: item.aliases
				? [item.aliases]
				: [];
		const rawValues = [item.value, item.key, item.path, item.text, ...customAliases]
			.filter(Boolean)
			.flatMap((value) => toAliasVariants(value));

		return new Set(rawValues);
	};
	const hasMenuPermissionMatch = (permissionValue, menuItem) => {
		const permissionAliases = toAliasVariants(permissionValue);
		if (!permissionAliases.length) return false;

		const menuAliases = toAliasSet(menuItem);
		return permissionAliases.some((alias) => menuAliases.has(alias));
	};

	const sitemenu = useMemo(() => {
		return [
			{
				value: 'appointments',
				key: 'vbookingPages',
				active: false,
				subMenu: [
					{
						value: 'Pending Appointments',
						key: 'v_book',
						active: false,
						path: '/appointment/pending',
					},
					{
						value: 'Cancelled Appointments',
						key: 'v_cancelled_book',
						active: false,
						path: '/appointment/cancelled',
					},
					{
						value: 'Completed Appointments',
						key: 'v_completed_book',
						active: false,
						path: '/appointment/completed',
					},
					{
						value: 'Expired Appointments',
						key: 'v_expired_book',
						active: false,
						path: '/appointment/expired',
					},
				],
			},
			{
				value: 'orders',
				key: 'Orders_v',
				active: false,
				path: '/orders',
			},
			{
				value: 'calendar',
				key: 'Calendar_v',
				active: false,
				path: '/calendar',
			},

			{
				value: 'employee',
				key: 'Manage_e',
				active: false,
				subMenu: [
					{
						value: 'Leave Requests',
						key: 'emp_leave',
						active: false,
						path: '/employee/leave-requests',
					},
					{
						value: 'Employee',
						key: 'emp_list',
						active: false,
						path: '/employee/list',
					},
					{
						value: 'Shifts',
						key: 'emp_shed',
						active: false,
						path: '/employee/shifts',
					},
					{
						value: 'Worker Schedule',
						key: 'emp_work_shed',
						active: false,
						path: '/employee/worker-schedule',
					},
				],
			},

			{
				value: 'reports',
				key: 'e_reports',
				active: true,
			},
			{
				value: 'Past Bookings',
				key: 'e_complete',
				active: true,
			},
			{
				value: 'Upcoming Bookings',
				key: 'e_pending',
				active: true,
			},
			{
				value: 'leave',
				key: 'employeeLeave',
				active: true,
			},
			{
				value: 'reports',
				key: 'Manage_report',
				active: false,
				subMenu: [
					{
						value: 'Orders',
						key: 'orders',
						active: false,
						path: '/reports/orders',
					},
					{
						value: 'Appointments',
						key: 'appointment',
						active: false,
						path: '/reports/appointments',
					},
					{
						value: 'Attendance',
						key: 'attendance',
						active: false,
						path: '/reports/attendance',
					},
					{
						value: 'Completed Refund',
						key: 'crefund',
						active: false,
						path: '/reports/completed-refund',
					},
					{
						value: 'Commission',
						key: 'manage_comm',
						active: false,
						path: '/reports/commission',
					},
					{
						value: 'Payments',
						key: 'payment',
						active: false,
						path: '/reports/payments',
					},
					{
						value: 'Products',
						key: 'product',
						active: false,
						path: '/reports/products',
					},
					{
						value: 'Inventory',
						key: 'inventory',
						active: false,
						path: '/reports/inventory',
					},
					{
						value: 'Schedule',
						key: 'shedule',
						active: false,
						path: '/reports/schedule',
					},
				],
			},
			{
				value: 'customers',
				key: 'Manage_u',
				active: false,
				path: '/customers',
			},
			{
				value: 'finance',
				key: 'Transaction',
				active: false,
				subMenu: [
					{
						value: 'Cheque',
						key: 'cheque',
						active: false,
						path: '/transaction/cheque',
					},
					{
						value: 'Expenses',
						key: 'expences',
						active: false,
						path: '/transaction/expences',
					},
					{
						value: 'Expences Type',
						key: 'extype',
						active: false,
						path: '/transaction/extype',
					},
					{
						value: 'Income',
						key: 'income',
						active: false,
						path: '/transaction/income',
					},
					{
						value: 'Payroll',
						key: 'manage_pay',
						active: false,
						path: '/transaction/payroll',
					},
				],
			},
			{
				value: 'services',
				key: 'servicePages',
				active: false,
				subMenu: [

					{
						value: 'Services',
						key: 'add_serv',
						active: false,
						path: '/services/list',
					},
					{
						value: 'Category',
						key: 'add_cat',
						active: false,
						path: '/services/category',
					},
				],
			},
			{
				value: 'refunds',
				key: 'Manage_refunds',
				active: false,
				subMenu: [
					{
						value: 'Pending Refunds',
						key: 'refund_list',
						active: false,
						path: '/refunds/requested',
					},
					{
						value: 'Completed Refunds',
						key: 'refund_paid',
						active: false,
						path: '/refunds/completed',
					},
				],
			},
			{
				value: 'products',
				key: 'addProduct',
				active: false,
				path: '/viewproducts',
			},
			{
				value: 'promotions',
				key: 'add_promo',
				active: false,
				path: '/services/promotions',
			},

			{
				value: 'branches',
				key: 'branchList',
				active: false,
				path: '/branch',
			},
			{
				value: 'settings',
				key: 'Manage_setting',
				active: false,
				aliases: ['activities'],
				subMenu: [
					{
						value: 'Sliders',
						key: 'sliderSetting',
						active: false,
						path: '/sliders',
					},
					{
						value: 'Settings',
						key: 'employeeSetting',
						active: false,
						path: '/settings',
					},
					{
						value: 'Activity Log',
						key: 'activityLog',
						active: false,
						path: '/activitylog',
						aliases: ['Activity Logs'],
					},
				],
			},
			
		];
	}, [token?.session_key]);
	// }, [reset,token]);

	useEffect(() => {
		const gettoken = JSON.parse(localStorage.getItem('user-auth'));
		if (gettoken) {
			setToken(gettoken);
			console.log("gettoken", gettoken);
		}
	}, []);

	useEffect(() => {
		const nextPathpermission = [];

		if (token.user_roles_id) {
			if (token.is_worker_emp === 1 && token.permission.length > 0) {
				// if (token.user_roles_id === 2 && token.permission.length > 0) {
				const tempmap = [...sitemenu];
				const temp = cloneMenu();

				tempmap.forEach((b, i) => {
					let mainindex;
					if (
						token.permission.some((Item, r) => {
							if (hasMenuPermissionMatch(Item.parent_module, b)) {
								mainindex = r;
								return true;
							}
							return false;
						})
					) {
						tempmap[i].active = true;
						if (tempmap[i].subMenu !== undefined) {
							const submenu = [...tempmap[i].subMenu];
							submenu.forEach((a, s) => {
								let tempindex;

								if (
									token.permission.some((Sub, i) => {
										if (
											hasMenuPermissionMatch(Sub.module_name, a) &&
											hasMenuPermissionMatch(Sub.parent_module, b)
										) {
											tempindex = i;
											return true;
										}
										return false;
									})
								) {
									submenu[s].active = true;
									if (tempindex != undefined) {
										upsertPathPermission(
											nextPathpermission,
											a.path,
											token.permission[tempindex].permission,
										);
									}
								}
							});
							tempmap[i].subMenu = submenu;
						} else {
							if (mainindex != undefined) {
								if (token.permission[mainindex].permission != undefined) {
									upsertPathPermission(
										nextPathpermission,
										b.path,
										token.permission[mainindex].permission,
									);
								}
							}
						}
					}
				});
				tempmap.forEach((b) => {
					if (!b.active) {
						delete temp[b.key];
					} else {
						if (b.subMenu !== undefined) {
							b.subMenu.forEach((q) => {
								if (!q.active) {
									if (temp[b.key] != undefined && temp[b.key].subMenu != undefined && temp[b.key].subMenu[q.key] != undefined) {
										temp[b.key].subMenu[q.key].hide = true;
									}
								} else {
									if (temp[b.key] != undefined && temp[b.key].subMenu != undefined && temp[b.key].subMenu[q.key] != undefined) {
										temp[b.key].subMenu[q.key].hide = false;
									}
								}
							});
						}
					}
				});

				ensureWorkerSettingsMenu(temp);
				setPathpermission(nextPathpermission);
				setMenudemopages(temp);
			} else if (token.user_roles_id > 2 && token.permission.length > 0) {
				const tempmap = [...sitemenu];
				const temp = cloneMenu();
				delete temp.e_complete;
				delete temp.e_pending;
				tempmap.forEach((b, i) => {
					let mainindex;

					if (
						token.permission.some((Item, r) => {
							if (hasMenuPermissionMatch(Item.parent_module, b)) {
								mainindex = r;
								return true;
							}
							return false;
						})
					) {
						tempmap[i].active = true;
						if (tempmap[i].subMenu !== undefined) {
							const submenu = [...tempmap[i].subMenu];
							submenu.forEach((a, s) => {
								let tempindex;

								if (
									token.permission.some((Sub, i) => {
										if (
											hasMenuPermissionMatch(Sub.module_name, a) &&
											hasMenuPermissionMatch(Sub.parent_module, b)
										) {
											tempindex = i;
											return true;
										}
										return false;
									})
								) {
									submenu[s].active = true;
									if (tempindex != undefined) {
										upsertPathPermission(
											nextPathpermission,
											a.path,
											token.permission[tempindex].permission,
										);
									}
								}
							});
							tempmap[i].subMenu = submenu;
						} else {
							if (mainindex != undefined) {
								if (token.permission[mainindex].permission != undefined) {
									upsertPathPermission(
										nextPathpermission,
										b.path,
										token.permission[mainindex].permission,
									);
								}
							}
						}
					}
				});
				tempmap.forEach((b) => {
					if (!b.active) {
						delete temp[b.key];
					} else {
						if (b.subMenu !== undefined) {
							b.subMenu.forEach((q) => {
								if (!q.active) {
									if (temp[b.key] != undefined && temp[b.key].subMenu != undefined && temp[b.key].subMenu[q.key] != undefined) {
										temp[b.key].subMenu[q.key].hide = true;
									}
								} else {
									if (temp[b.key] != undefined && temp[b.key].subMenu != undefined && temp[b.key].subMenu[q.key] != undefined) {
										temp[b.key].subMenu[q.key].hide = false;
									}
								}
							});
						}
					}
				});
				temp.e_reports.subMenu.e_app_book.hide = true;
				temp.e_reports.subMenu.e_sched_book.hide = true;

				setPathpermission(nextPathpermission);
				setMenudemopages(temp);
			} else if (token.is_worker_emp === 1 && token.permission.length === 0) {
				// } else if (token.user_roles_id === 2 && token.permission.length === 0) {
				const temp = cloneMenu();
				delete temp.vbookingPages;
				delete temp.Orders_v;
				delete temp.Calendar_v;
				delete temp.servicePages;
				delete temp.addProduct;
				delete temp.add_promo;
				delete temp.branchList;
				delete temp.Manage_e;
				delete temp.Manage_u;
				delete temp.Transaction;
				delete temp.Manage_report;
				delete temp.Manage_refunds;

				ensureWorkerSettingsMenu(temp);
				setPathpermission([]);
				setMenudemopages(temp);
			}
		} else {
			const temp = cloneMenu();
			delete temp.e_complete;
			delete temp.e_pending;
			delete temp.vbookingPages;
			delete temp.Orders_v;
			delete temp.Calendar_v;
			delete temp.servicePages;
			delete temp.addProduct;
			delete temp.add_promo;
			delete temp.branchList;
			delete temp.Manage_e;
			delete temp.Manage_u;
			delete temp.Transaction;
			delete temp.Manage_report;
			delete temp.Manage_refunds;
			temp.e_reports.subMenu.e_app_book.hide = true;
			temp.e_reports.subMenu.e_sched_book.hide = true;
			setPathpermission([]);
			setMenudemopages(temp);
		}
	}, [token?.session_key]);
	// }, [token?.session_key, reset]);
	useEffect(() => {
		let reftimeout;

		if (token.user_roles_id) {
			reftimeout = setTimeout(() => {
				let isallow = false;
				const path = `${location.pathname}`.substring(1);
				Object.keys(menudemopages).forEach((a) => {
					if (menudemopages[a].subMenu != undefined) {
						Object.keys(menudemopages[a].subMenu).forEach((b) => {
							if (menudemopages[a].subMenu[b].hide != true) {
								if (menudemopages[a].subMenu[b].path === path) {
									isallow = true;
								}
							}
						});
					}
				});
				if (
					path !== 'dashboard' &&
					path !== 'Leave' &&
					path !== 'orders' &&
					path !== 'calendar' &&
					path !== 'promotions' &&
					path !== 'viewproducts' &&
					path !== 'customers' &&
					path !== 'branch'
				) {
					if (!isallow) {
						// navigate('/dashboard');
					}
				}

				setLoading(false);
			}, 1000 * 2);
		}
		return () => {
			clearTimeout(reftimeout);
		};
	}, [location.pathname, token?.session_key, menudemopages]);
	const values = useMemo(
		() => ({
			token,
			menudemopages,
			pathpermission,
			setToken,
			setReset,
		}),
		[token?.session_key, menudemopages, pathpermission],
	);

	return <userAuth.Provider value={values}>{children}</userAuth.Provider>;
};

export default UserContextProvider;
